module.exports = __webpack_public_path__ + "static/img/pic-01@2x.c8bef05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-01@2x.png
// module id = LW1D
// module chunks = 1